import { AgenceEntity } from './agence.entity';
import { AssetManagerEntity } from './assetManager.entity';
import { PartenaireEntity } from './partenaire.entity';
import { ProfilEntity } from './profil.entity';

export type ProfilType =
  | 'admin'
  | 'resp_commercial'
  | 'commercial'
  | 'responsable'
  | 'chef_agence'
  | 'gestionnaire'
  | 'sadmin';

export class ConnectedUserEntity {
  id: string;
  url: string;
  agence: AgenceEntity;
  authentifie: boolean;
  nom: string;
  prenom: string;
  profils: ProfilEntity[];
  manager: AssetManagerEntity;
  partenaire: PartenaireEntity;
  email: string;
  token: string;
  nextAuthDate: number;

  constructor(user: ConnectedUserEntity) {
    this.id = user?.id;
    this.url = user?.url;
    this.agence = user?.agence;
    this.nom = user?.nom;
    this.prenom = user?.prenom;
    this.authentifie = user?.authentifie;
    this.email = user?.email;
    this.token = user?.token;
    this.profils = user?.profils;
    this.manager = user?.manager;
    this.partenaire = user?.partenaire;
    this.nextAuthDate = user?.nextAuthDate;
  }

  isConnected(): boolean {
    if (this.authentifie && new Date().getTime() < this.nextAuthDate) {
      return true;
    } else {
      return false;
    }
  }
}
